import React from 'react';
import PropTypes from 'prop-types';

import SellingPointsBlock from './SellingPointsBlock';

const MAX_SELLING_POINTS = 5;

export const getKeySellingPoints = (rooms) => {
  // Gets the selling points of the first room that has any
  const roomWithPoints = rooms.find((room) => room.key_selling_points.length > 0);
  if (!roomWithPoints) {
    return null;
  }
  const totalItems = roomWithPoints ? roomWithPoints.key_selling_points : [];
  return totalItems.filter((item, index) => index < MAX_SELLING_POINTS);
};

const RoomKeySellingPoints = (props) => {
  const { rooms, lang, flat } = props;
  const sellingPoints = getKeySellingPoints(rooms);
  if (!sellingPoints) {
    return null;
  }

  return (
    <SellingPointsBlock room={rooms[0]} lang={lang} max={MAX_SELLING_POINTS} flat={flat}/>
  );
};

RoomKeySellingPoints.propTypes = {
  rooms: PropTypes.array.isRequired,
  lang: PropTypes.string.isRequired,
  flat: PropTypes.bool,
};

export default RoomKeySellingPoints;
